import { Notification } from '../../../../../models/Notification'
import { StylesScene } from '../../../../../models/Story'
import { getNotificationImgPathes } from '../../resolveImgPath'

type TUserAddLinkedStyles = {
    [key: string]: StylesScene
}

const UserAddLinkedStyles: TUserAddLinkedStyles = {
    'Group': {
        
    },
    'Public': {
        mainImg: {
            container: {
                width: 280,
                height: 220,
                position: 'absolute',
                top: 228,
                left: 20,
                zIndex: 1,
                border: '8px solid #fff',
                borderRadius: 2,
            }
        },
        dataTypeTag: {
            container: {
                top: 200,
                right: 15,
                position: 'absolute',
                transform: 'rotate(-8deg)',
                width: 143,
            },
            text: {
                textShadow: '0 2px 4px rgba(0, 0, 0, 0.15)',
                fontFamily: 'Roboto Slab',
                fontSize: 20,
                fontWeight: 800,
                lineHeight: 2.8,
                letterSpacing: 0,
                color: '#ffd288',
                zIndex: 2,
            }
        },
        docTitle: {
            container: {
                position: 'absolute',
                top: 230,
                left: 21,
                padding: '6px',
                borderRadius: 4,
                zIndex: 2,
                backgroundColor: '#fff',
                maxHeight: 125,
                maxWidth: 240
            },
            text: {
                fontFamily: 'Rubik',
                fontSize: 18,
                fontWeight: 'bold',
                fontStretch: 'normal',
                fontStyle: 'normal',
                lineHeight: 1.5,
                letterSpacing: 0,
                textAlign: 'center',
                color: '#0e0e14',
            }
        },
        dataTypeTitle: {
            container: {
                top: 240,
                right: 10,
                position: 'absolute',
                transform: 'rotate(-8deg)',
                zIndex: 2,
                width: 140
            },
            text: {
                textShadow: '0 2px 4px rgba(0, 0, 0, 0.15)',
                fontFamily: 'Roboto Slab',
                fontSize: 20,
                fontWeight: 600,
                lineHeight: 2.8,
                letterSpacing: 0,
                color: '#fff',
                textTransform: 'uppercase',
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                whiteSpace: 'nowrap', 
              }
        },
        dataTypeTitleLinked: {
            container: {
                bottom: 13,
                left: 46,
                position: 'absolute',
                transform: 'rotate(-6deg)',
                zIndex: 2,
                width: 300,
            },
            text: {
                textShadow: '0 2px 4px rgba(0, 0, 0, 0.15)',
                fontFamily: 'Roboto Slab',
                fontSize: 24,
                fontWeight: 600,
                lineHeight: 2.8,
                letterSpacing: 0,
                color: '#fff',
                textTransform: 'uppercase',
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                whiteSpace: 'nowrap', 
            }
        },
        dataTypeTagLinked: {
            container: {
                bottom: 45,
                left: 4,
                position: 'absolute',
                transform: 'rotate(-6deg)',
                width: 300
            },
            text: {
                textShadow: '0 2px 4px rgba(0, 0, 0, 0.15)',
                fontFamily: 'Roboto Slab',
                fontSize: 28,
                fontWeight: 800,
                lineHeight: 2.8,
                letterSpacing: 0,
                color: '#ffd288',
                zIndex: 2,
                }
        },
        mainImgLinked: {
            container: {
                width: 280,
                height: 220,
                position: 'absolute',
                bottom: 120,
                right: 20,
                zIndex: 1,
                border: '8px solid #fff',
                borderRadius: 2,
            }
        },
        docTitleLinked: {
            container: {
                position: 'absolute',
                bottom: 122,
                right: 26,
                padding: '6px',
                borderRadius: 4,
                zIndex: 2,
                backgroundColor: '#fff',
                maxHeight: 125,
                maxWidth: 240
            },
            text: {
                fontFamily: 'Rubik',
                fontSize: 18,
                fontWeight: 'bold',
                fontStretch: 'normal',
                fontStyle: 'normal',
                lineHeight: 1.5,
                letterSpacing: 0,
                textAlign: 'center',
                color: '#0e0e14',
            }
        }
    }
}

export const getUserLinkItemBackground = (notif: Notification): [string, StylesScene] => {
    return [getNotificationImgPathes(notif.systemActionTypeUid)[notif.groupType], UserAddLinkedStyles[notif.groupType]]
}